import { useContext } from "react";
import { AuthenticationContext } from "../../services/authentication/authentication.context";
import classNames from "classnames";
import { CarContext } from "../../services/products/product.context";

export const LoadingIndicator = () => {

    const { isLoading } = useContext(AuthenticationContext);
    const { loading } = useContext(CarContext);

    return (
        <div className={classNames({"dark-bg": isLoading}, "flx-cnt")}>
            {(isLoading || loading) &&
            <div className="dark-bg flx-cnt">
                <img
                    src="./svgs/loader.svg"
                    alt=""
                    className="loader-img"
                    width={50}
                    height={50}
                />
            </div>
            }
        </div>
    )
}